import * as React from "react";
const SvgFiRrIncognito = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-incognito_svg__a)">
      <path
        fill="#062147"
        d="M16.5 17a3.5 3.5 0 0 0-3.235 2.174 4.7 4.7 0 0 0-2.53 0 3.494 3.494 0 1 0 .193 2.033A3.5 3.5 0 0 1 12 21c.366.013.728.083 1.072.207A3.5 3.5 0 1 0 16.5 17m-9 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m9 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m3.475-13.325C19.709.612 15.3.026 15.105.006A1 1 0 0 0 15 0a4.5 4.5 0 0 0-2.416.818 1.02 1.02 0 0 1-1.167 0C10.707.318 9.867.035 9 0a1 1 0 0 0-.1.006c-.194.02-4.6.606-4.87 8.669C2.693 9.122 0 10.243 0 12c0 3.69 6.194 4 12 4s12-.31 12-4c0-1.757-2.693-2.878-4.025-3.325m-10.92-6.67c.436.047.854.202 1.215.452a3.03 3.03 0 0 0 3.461 0 2.64 2.64 0 0 1 1.206-.452c.445.106 2.909.964 3.056 6.858A13.2 13.2 0 0 1 12 10a13.2 13.2 0 0 1-5.993-1.136C6.155 2.92 8.658 2.1 9.055 2.005M12 14c-8.265 0-10-1.088-10.012-1.918a6.04 6.04 0 0 1 2.86-1.574A14.56 14.56 0 0 0 12 12a14.56 14.56 0 0 0 7.152-1.492A6.8 6.8 0 0 1 22 12c0 .912-1.735 2-10 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-incognito_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrIncognito;
